<template>
    <BaseField class="stretch" v-bind="$props" v-on="$listeners">
        <input
            type="number"
            class="value-field"
            :placeholder="placeholder"
            :value="value"
            step="0.01"
            min="0.01"
            @input="$emit('update:value', parseFloat($event.target.value))"
        />
    </BaseField>
</template>

<script>
import BaseField from '@/pages/monetize/segments/segmentForm/fields/BaseField.vue';

export default {
    name: 'FloatField',
    components: { BaseField },
    props: {
        ...BaseField.props,
        value: Number,
        placeholder: String
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/input.scss";

input[type="number"] {
    width: 80px;
    padding-right: 0;
}
</style>
